import React from 'react';
import { repConfig } from '../../config';
import { Phone, Award, ShieldCheck } from '../ui/Icons';

export function RepHeader({ variant = 'compact' }) {
  if (variant === 'large') {
    return (
      <div className="glass-card p-4 md:p-8 rounded-2xl md:rounded-3xl flex flex-col items-center gap-3 md:gap-6 text-center relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-brand-blue/10 blur-[50px] rounded-full" />
        <div className="flex-1 min-w-0">
          <h3 className="font-heading text-lg md:text-3xl font-bold">{repConfig.name}</h3>
          <p className="text-gray-400 text-xs md:text-sm font-medium mb-1">{repConfig.title}</p>
          <p className="text-[10px] md:text-sm text-gray-300 italic mb-3">"{repConfig.tagline}"</p>
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4">
            <span className="flex items-center gap-1 text-[9px] md:text-xs font-semibold bg-white/5 px-2 py-1 rounded-full text-blue-400">
              <Award size={12} /> {repConfig.experience}
            </span>
            <span className="flex items-center gap-1 text-[9px] md:text-xs font-semibold bg-white/5 px-2 py-1 rounded-full text-emerald-400">
              <ShieldCheck size={12} /> Verified Professional
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center bg-white/5 backdrop-blur-md rounded-2xl p-3 border border-white/10 w-fit mx-auto md:mx-0">
      <div className="text-xs md:text-sm font-semibold">{repConfig.name}</div>
      <div className="text-[10px] md:text-xs text-brand-blue flex items-center gap-1 mt-1">
        <Phone size={10} />
        <a href={`tel:${repConfig.phoneClean}`} className="hover:underline">{repConfig.phone}</a>
      </div>
    </div>
  );
}